import { getFetchBase } from './get-fetch-base';

export function getMediaUrl(source: string | null | undefined) {
  if (!source) return null;

  if (source && !source.split('/')[0]) {
    return `${getFetchBase()}${source}`;
  } else {
    return `${getFetchBase()}/${source}`;
  }
}
